import React from "react";
import Navbar from "./components/Navbar/Navbar";
import { useSelector } from "react-redux";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Skills from "./components/Skills/Skills";
import Portfolio from "./components/portfolio/Portfolio";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer";

const App = () => {
  const theme = useSelector((state) => state.theme.value);
  return (
    <div className={`wrapper ${theme ? "dark" : "theme"}`}>
      <Navbar />
      <Hero />
      <About />
      <Skills />
      <Portfolio />
      <Contact/>
      <Footer/>
    </div>
  );
};

export default App;
